<template>
  <div>
    <mingxi :pageType="1"> </mingxi> 
    <!-- mac_manage_flag 用于下级页面接收的参数 -->
  </div>
</template>
<script>
import mingxi from '../../tongyong/mingxi.vue';
 
export default {

  components: {
    mingxi: mingxi 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
